export const useEmptyScheduleStyles = () => {
  return {
    wrapper: {
      p: '40px',
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    icon: {
      height: '320px',
      width: '320px',
      objectFit: 'contain',
      opacity: 0.7,
    },
    text: {
      maxWidth: '50%',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: '14px',
      my: '32px',
    },
    button: { textTransform: 'none', fontWeight: 600 },
  };
};
